<template>
  <div>
    <b-card-actions
      title="Filters"
      action-collapse
      collapsed
    >
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Merchant"
            label-for="merchant"
          >
            <v-select
              v-model="filters['merchant_id']"
              :options="merchantOptions"
              :reduce="option => option.id"
              label="name"
              placeholder="Select Merchant"
              @input="onClickDeselectAll()"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Rider Deposit Status"
            label-for="deposit_status"
          >
            <v-select
              v-model="filters['staff_deposit_status']"
              :options="financeStatusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Agent Deposit Status"
            label-for="deposit_status"
          >
            <v-select
              v-model="filters['agency_deposit_status']"
              :options="financeStatusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col
          v-if="selectedCard !== 'allOrders' && selectedCard !== 'pendingDelivery' && selectedCard !== 'toReturn' && selectedCard !== 'onReturned' && selectedCard !== 'totalFinance' && selectedCard !== 'delivery_charge'"
          cols="12"
          md="3"
        >
          <b-form-group
            label="Delivery Date"
            label-for="delivery-date"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['status_date']"
                :opens="'left'"
                @update="updateDateRange('status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          v-if="selectedCard == 'pendingDeposit' || selectedCard == 'deposited' || selectedCard == 'approved'"
          cols="12"
          md="3"
        >
          <b-form-group
            :label="selectedCard == 'pendingDeposit'?'Invoice Create Date' : selectedCard == 'deposited'? 'Deposited Date':'Approved Date'"
            label-for="finance-status-date"
          >
            <div class="position-relative">
              <AdvancedDateFilter
                :date-value="filters['invoice_status_date']"
                :opens="'right'"
                @update="updateDateRange('invoice_status_date', $event)"
              />
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-group
            label="Branch Deposit Status"
            label-for="deposit_status"
          >
            <v-select
              v-model="filters['branch_deposit_status']"
              :options="financeStatusOptions"
              :reduce="option => option.key"
              label="name"
              placeholder="Select Status"
            >
              <template v-slot:option="option">
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Apply and Clear Filters -->
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :filters="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </b-card-actions>
    <div>
      <b-row class="match-height">
        <b-col md="3">
          <overview-card
            title="All Orders"
            :subtitle="allOrderStats.count !== undefined && allOrderStats.count !== null ? allOrderStats.count + ' Orders' : 'Loading...'"
            :sum="(allOrderStats.total)"
            :border-variant="selectedCard == 'allOrders' ? 'primary' : ''"
            tooltip-description="All orders given to the courier company by the Merchant."
            icon="MenuIcon"
            indicator-color="#67b7b7 "
            @click.native="onCardSelect('allOrders',''); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Pending Delivery"
            :subtitle="pendingDeliveryStats.count !== undefined && pendingDeliveryStats.count !== null ? pendingDeliveryStats.count + ' Orders' : 'Loading...'"
            :sum="(pendingDeliveryStats.total)"
            :border-variant="selectedCard == 'pendingDelivery' ? 'primary' : ''"
            tooltip-description="All Merchant orders except delivered and returned orders."
            icon="RepeatIcon"
            indicator-color="#6a76b0"
            @click.native="onCardSelect('pendingDelivery','key_2,key_4,key_5,key_6,key_8,key_9,key_10,key_11,key_12,key_15,key_16,key_26,key_27,key_28,key_29','status'); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Returned Orders"
            :subtitle="returnOrdersStats.count !== undefined && returnOrdersStats.count !== null ? returnOrdersStats.count + ' Orders' : 'Loading...'"
            :sum="(returnOrdersStats.total)"
            :border-variant="selectedCard == 'toReturn' ? 'primary' : ''"
            tooltip-description="All Merchant orders that are either returned to the client or ready to be returned to the client."
            icon="Minimize2Icon"
            indicator-color="#64c778"
            @click.native="onCardSelect('toReturn','key_17,key_18,key_19,key_20,key_21','status'); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Delivered Orders"
            :subtitle="deliveredOrdersStats.count !== undefined && deliveredOrdersStats.count !== null ? deliveredOrdersStats.count + ' Orders' : 'Loading...'"
            :sum="(deliveredOrdersStats.total)"
            :border-variant="selectedCard == 'delivered' ? 'primary' : ''"
            tooltip-description="All Merchant Orders that are either delivered, delivered by pickup rider or partially delivered."
            icon="CheckSquareIcon"
            indicator-color="#48d765"
            @click.native="onCardSelect('delivered','key_7,key_13,key_14','status'); addTwoExcelColumns(true);"
          />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="6">
          <overview-card
            title="Delivery Income"
            :subtitle="deliveryIncomeStats.count !== undefined && deliveryIncomeStats.count !== null ? deliveryIncomeStats.count + ' Orders' : 'Loading...'"
            :sum="(deliveryIncomeStats.total)"
            :border-variant="selectedCard == 'delivery_charge' ? 'primary' : ''"
            tooltip-description="The total delivery charge income of all merchant (Delivered, delivered by pickup rider, partially delivered, returned to client and received by client) orders. "
            icon="TruckIcon"
            indicator-color="#164cc9"
            @click.native="onCardSelect('delivery_charge','key_7,key_13,key_14,key_20,key_21','status'); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="6">
          <overview-card
            title="Commission Income"
            :subtitle="commisionIncomeStats.count !== undefined && commisionIncomeStats.count !== null ? commisionIncomeStats.count + ' Orders' : 'Loading...'"
            :sum=" (commisionIncomeStats.total || 0)"
            :border-variant="selectedCard == 'merchantCommission' ? 'primary' : ''"
            tooltip-description="The total Merchant commission income of all (Delivered, delivered by pickup rider, partially delivered, returned to client and received by client) orders."
            icon="DollarSignIcon"
            indicator-color="#10882b"
            @click.native="onCardSelect('merchantCommission','key_7,key_13,key_14,key_20,key_21','status'); addTwoExcelColumns(true,1);"
          />
        </b-col>
      </b-row>
      <b-row class="match-height">
        <b-col md="3">
          <overview-card
            title="To Be Invoiced"
            :subtitle="toBeInvoicedStats.count !== undefined && toBeInvoicedStats.count !== null ? toBeInvoicedStats.count + ' Orders' : 'Loading...'"
            :sum="(toBeInvoicedStats.total)"
            :border-variant="selectedCard == 'toInvoice' ? 'primary' : ''"
            tooltip-description="Total of delivered & returned orders, but not assigned to any invoice yet(for cash order calculation only the collected COD amount is added)."
            icon="ClipboardIcon"
            indicator-color="#48c2d7"
            @click.native="onCardSelect('toInvoice','false&filter[status]=key_7,key_13,key_14,key_20,key_21','merchant_invoice_id'); addTwoExcelColumns(true,3);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Pending Deposit"
            :subtitle="pendingDepositStats.count !== undefined && pendingDepositStats.count !== null ? pendingDepositStats.count + ' Orders' : 'Loading...'"
            :sum="(pendingDepositStats.total)"
            :border-variant="selectedCard == 'pendingDeposit' ? 'primary' : ''"
            tooltip-description="Total of delivered & returned orders and assigned to a invoice, but not paid yet(for cash order calculation only the collected COD amount is added)."
            icon="RefreshCwIcon"
            indicator-color="#adb65c"
            @click.native="onCardSelect('pendingDeposit','f_key_1','merchant_invoice'); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Deposited"
            :subtitle="depositedStats.count !== undefined && depositedStats.count !== null ? depositedStats.count + ' Orders' : 'Loading...'"
            :sum="(depositedStats.total)"
            :border-variant="selectedCard == 'deposited' ? 'primary' : ''"
            tooltip-description="Total of delivered & returned orders and assigned to a invoice and paid(for cash order calculation only the collected COD amount is added)."
            icon="CheckIcon"
            indicator-color="#70af51"
            @click.native="onCardSelect('deposited','f_key_2','merchant_invoice'); addTwoExcelColumns(true);"
          />
        </b-col>
        <b-col md="3">
          <overview-card
            title="Approved"
            :subtitle="approvedStats.count !== undefined && approvedStats.count !== null ? approvedStats.count + ' Orders' : 'Loading...'"
            :sum="(approvedStats.total)"
            :border-variant="selectedCard == 'approved' ? 'primary' : ''"
            tooltip-description="Total of delivered & returned orders and assigned to a invoice and paid and approved by merchant(for cash order calculation only the collected COD amount is added)."
            icon="CheckCircleIcon"
            indicator-color="#b78164"
            @click.native="onCardSelect('approved','f_key_3','merchant_invoice'); addTwoExcelColumns(true);"
          />
        </b-col>
      </b-row>
    </div>
    <div>
      <b-card
        no-body
      >
        <div>
          <div
            class="m-2"
          >
            <!-- input -->
            <b-row class="d-sm-flex align-items-start">
              <b-col
                md="12"
                lg="8"
                class="d-block d-sm-flex flex-wrap justify-content-start align-items-center mb-1 mb-md-0"
              >
                <div
                  v-if="selectedCard=='toInvoice'"
                >
                  <b-button
                    v-can="'merchant-finance-create'"
                    :disabled="selectedWaybillArray.length === 0"
                    class="mr-1 mt-1"
                    variant="success"
                    @click="onClickGenerateInvoice()"
                  >
                    Generate Invoice
                  </b-button>
                </div>
              </b-col>
              <b-col
                class="d-flex justify-content-end align-items-center mb-1 mb-md-0"
              >
                <ReportTableButtons
                  :items="rows"
                  :json_fieldz="json_fields"
                  :name="`MerchantOverview - Page ${page}.xls`"
                  :bulkname="`MerchantOverview.xls`"
                  :fetch="fetchOrderListNoPagination"
                  @refresh="onClickRefresh"
                />
              </b-col>
            </b-row>
            <b-row v-if="selectedCard == 'toInvoice'">
              <div class="font-weight-bolder text-muted mt-1 ml-1">
                {{ `${selectedWaybillArray.length} record${selectedWaybillArray.length === 1 ? '':'s'}` }} selected
              </div>
            </b-row>
          </div>

          <!-- table -->
          <b-overlay
            id="overlay-background"
            variant="light"
            opacity="0.30"
            blur="10px"
            rounded="sm"
          >
            <b-table
              striped
              hover
              responsive
              :per-page="perPage"
              :items="rows"
              :fields="selectedCard=='toInvoice'?fields:fields.slice(1,fields.length)"
              show-empty
              sticky-header="100vh"
              class="hide-vertical-scroll"
              @sort-changed="sortChanged"
            >
              <template #empty>
                <TableDataFetching
                  :rows="rows"
                  :data-loading="dataLoading"
                />
              </template>
              <template
                v-if="selectedCard == 'toInvoice'"
                #head(id)
              >
                <div class="d-flex align-items-start">
                  <div>
                    <b-form-checkbox
                      id="selectAllCheckbox"
                      v-model="selectAllCheckbox"
                      name="selectAllCheckbox"
                      @change="onClickSelectAllCheckbox()"
                    />
                  </div>
                </div>
              </template>
              <template
                v-if="selectedCard=='toInvoice'"
                #cell(id)="data"
              >
                <div class="d-flex align-items-start">
                  <div>
                    <div class="font-weight-bolder">
                      <b-form-checkbox
                        v-model="selectedWaybillArray"
                        :value="data.item.waybill_number"
                      />
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(waybill_number)="data">
                <div class="d-flex align-items-center">
                  <b-avatar
                    :text="avatarText(getCustomerFieldValue(data.item, 'customer_name'))"
                    size="32"
                    variant="light-primary"
                  />
                  <div>
                    <div
                      class="font-weight-bolder ml-1 text-primary"
                      @click="onClickViewOrder(data.item.id)"
                    >
                      {{ data.value }}
                    </div>
                    <div class="font-small-2 ml-1">
                      {{ __dateTimeFormatter(data.item.created_at) }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.name)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ `${data.value}${data.item.walking_agency_deposit_id || data.item.walking_branch_deposit_id ? '&nbsp;[&nbsp;WC&nbsp;]' : ''}` }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(merchant.type)="data">
                <div class="d-flex align-items-start">
                  <div>
                    <div class="">
                      {{ data.item.order_setting.merchant_type }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(customer_email)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ getCustomerFieldValue(data.item, 'customer_name') }}
                    </div>
                    <div class="font-small-2">
                      {{ getCustomerFieldValue(data.item, 'customer_email') }}
                    </div>
                    <div class="font-small-2">
                      <div><b>Primary number: </b>{{ getCustomerFieldValue(data.item, 'customer_phone') }}</div>
                    </div>
                    <div class="font-small-2">
                      <div><b>Second number: </b>{{ getCustomerFieldValue(data.item, 'customer_secondary_phone') || '-' }}</div>
                    </div>
                    <div class="font-small-2">
                      {{ getCustomerFieldValue(data.item, 'customer_address') }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(rider_name)="data">
                <div class="d-flex align-items-center">
                  <div>
                    <div class="font-weight-bolder">
                      {{ data.item.rider ? `${data.item.rider.first_name} ${data.item.rider.last_name || ''}` : '---' }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider ? data.item.rider.email : '' }}
                    </div>
                    <div class="font-small-2">
                      {{ data.item.rider && data.item.rider.reference_id ? data.item.rider.reference_id : '' }}
                    </div>
                  </div>
                </div>
              </template>
              <template #cell(cod)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(collected_cod)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(merchant_commission)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(delivery_charge)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(commission)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(invoice_amount)="data">
                <span>{{ __numberWithCommas(data.value, true) }}</span>
              </template>
              <template #cell(rider_deposit)="data">
                <div
                  class="d-flex justify-content-center font-weight-bolder"
                  style="margin-bottom:2px;"
                >
                  {{ data.value.ref_no || '---' }}
                </div>
                <div class="d-flex justify-content-center">
                  <finance-status-badge
                    :status-key="data.item.rider_deposit_status? data.item.rider_deposit_status.name : ''"
                    :finance-status="financeStatusOptions"
                  />
                </div>
              </template>
              <template #cell(branch_deposit)="data">
                <div
                  class="d-flex justify-content-center font-weight-bolder"
                  style="margin-bottom:2px;"
                >
                  {{ data.item.agency_deposit ? data.item.agency_deposit.ref_no : (data.item.branch_deposit ? data.item.branch_deposit.ref_no : '---') }}
                </div>
                <div class="d-flex justify-content-center">
                  <finance-status-badge
                    :status-key="data.item.branch_deposit_status? data.item.branch_deposit_status.name : data.item.agency_deposit_status ? data.item.agency_deposit_status.name : ''"
                    :finance-status="financeStatusOptions"
                  />
                </div>
              </template>
              <template #cell(merchant_invoice)="data">
                <div
                  class="d-flex justify-content-center font-weight-bolder"
                  style="margin-bottom:2px;"
                >
                  {{ data.value.ref_no || '---' }}
                </div>
                <div class="d-flex justify-content-center">
                  <finance-status-badge
                    :status-key="data.item.invoice_status? data.item.invoice_status.name : ''"
                    :finance-status="financeStatusOptions"
                  />
                </div>
              </template>
              <template #cell(created_at)="data">
                {{ __dateTimeFormatter(data.value) }}
              </template>
              <template #cell(agency_deposit)="data">
                <div>
                  {{ data.value || '---' }}
                </div>
              </template>
              <template #cell(order_current_status.key)="data">
                <order-status-badge :status-key="data.value" />
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="12"
                      class="text-body align-middle mr-25"
                    />
                  </template>
                  <b-dropdown-item
                    v-can="'show-orders'"
                    @click="onClickViewOrder(data.item.id)"
                  >
                    <feather-icon icon="EyeIcon" />
                    View
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="data.item.rider_signature"
                    :href="`${bucketUrl}${data.item.rider_signature}`"
                    target="_blank"
                  >
                    <feather-icon icon="Edit2Icon" />
                    View Receiver's Signature
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <div class="mx-2 mb-2">
              <b-row
                cols="12"
              >
                <b-col
                  class="d-flex align-items-center justify-content-sm-start"
                  md="3"
                >
                  <label class="width-75">Per page</label>
                  <v-select
                    v-model="perPage"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="pageOptions"
                    :clearable="false"
                    class="per-page-selector d-inline-block width-100"
                  />
                </b-col>
                <!-- Pagination -->
                <b-col
                  class="d-flex align-items-center justify-content-sm-end"
                  md="9"
                >
                  <span class="text-muted pagination-text  mt-1 mt-md-0 mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
                  <b-pagination
                    v-model="page"
                    :per-page="perPage"
                    :total-rows="(meta.total)? meta.total : 0"
                    class="mb-0 mt-1 mt-sm-0"
                    first-number
                    last-number
                    next-class="next-item"
                    prev-class="prev-item"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-overlay>
        </div>
      </b-card>
    </div>
    <deposit-detail-modal ref="deposit_detail_modal" />
    <make-remark ref="add_make_remark" />
    <make-future-request ref="add_future_request" />
    <flag-details ref="flag_detail" />
    <view-order-modal ref="viewOrderModal" />
  </div>
</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BPagination,
  BRow,
  BOverlay,
  VBModal,
  BTable,
  BDropdown,
  BDropdownItem,
  VBTooltip,
} from 'bootstrap-vue'
import OrderStatusBadge from '@core/components/status/OrderStatusBadge.vue'
import FinanceStatusBadge from '@core/components/status/FinanceStatusBadge.vue'
import Ripple from 'vue-ripple-directive'
import AdvancedDateFilter from '@/components/AdvancedDateFilter/AdvancedDateFilter.vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Filter from '@core/mixins/filter'
import vSelect from 'vue-select'
import { avatarText } from '@core/utils/filter'
import { bucketUrl } from '@/constants/config'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import ViewOrderModal from '@/components/AllOrders/ViewOrderModal.vue'
import MakeRemark from '@/components/AllOrders/Remark/MakeRemark.vue'
import FlagDetails from '@/components/AllOrders/FlagDetails.vue'
import MakeFutureRequest from '@/components/AllOrders/MakeFutureRequest.vue'
import DepositDetailModal from '@/components/FinanceModuleForms/InfoModals/DepositDetailModal.vue'
import OverviewCard from '@core/components/overview-card/OverviewCard.vue'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import store from '@/store/index'
import FilterButtons from '@/components/Filter/FilterButtons.vue'

const OrderRepository = RepositoryFactory.get('order')
const FinanceRepository = RepositoryFactory.get('finance')
const merchantRepository = RepositoryFactory.get('merchant')
const riderRepository = RepositoryFactory.get('rider')
const OverviewDashboardRepository = RepositoryFactory.get('overviewdashboard')

export default {
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  components: {
    BAvatar,
    BButton,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BTable,
    BOverlay,
    vSelect,
    OrderStatusBadge,
    FinanceStatusBadge,
    OverviewCard,
    BDropdown,
    BDropdownItem,
    MakeRemark,
    MakeFutureRequest,
    FlagDetails,
    AdvancedDateFilter,
    ViewOrderModal,
    DepositDetailModal,
    BCardActions,
    FilterButtons,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage],
  data() {
    return {
      // Filters Start
      allOrderStats: { total: null, count: undefined },
      pendingDeliveryStats: { total: null, count: undefined },
      returnOrdersStats: { total: null, count: undefined },
      deliveredOrdersStats: { total: null, count: undefined },
      deliveryIncomeStats: { total: null, count: undefined },
      commisionIncomeStats: { total: null, count: undefined },
      toBeInvoicedStats: { total: null, count: undefined },
      pendingDepositStats: { total: null, count: undefined },
      depositedStats: { total: null, count: undefined },
      approvedStats: { total: null, count: undefined },
      filters: {
        status_date: {
          startDate: null,
          endDate: null,
        },
        invoice_status_date: {
          startDate: null,
          endDate: null,
        },
      },
      statusOptions: [],
      financeStatusOptions: [],
      riderOptions: [],
      merchantOptions: [],
      finance: [],
      options: {
        delimiter: {
          delimiter: ' to ',
          blocks: [4, 4],
          uppercase: true,
        },
      },
      // Filters End
      avatarText,
      bucketUrl,
      total: 0,
      meta: {},
      dataLoading: false,
      sort: '',
      perPage: 20,
      pageOptions: [10, 20, 50],
      totalRows: 1,
      page: 1,
      filterName: '',
      fields: [],
      json_fields: {
        'Waybill Number': 'waybill_number',
        Merchant: {
          field: 'merchant.name',
          callback: value => `"${value || '---'}"`,
        },
        'Merchant Type': {
          callback: value => value.order_setting.merchant_type,
        },
        'Customer Name': {
          field: 'customer_name',
          callback: value => `"${value || '---'}"`,
        },
        'Customer Email': {
          field: 'customer_email',
          callback: value => `"${value || '---'}"`,
        },
        'Customer Address': {
          field: 'customer_address',
          callback: value => `"${value || '---'}"`, // Wrap the address in double quotes
        },
        'Customer Phone': {
          field: 'customer_phone',
          callback: value => `"${value || '---'}"`,
        },
        'Second Phone Number': {
          field: 'customer_secondary_phone',
          callback: value => (value || '---'),
        },
        'Rider First Name': {
          field: 'rider.first_name',
          callback: value => `"${value || '---'}"`,
        },
        'Rider Last Name': {
          field: 'rider.last_name',
          callback: value => `"${value || '---'}"`,
        },
        'Rider Email': {
          field: 'rider.email',
          callback: value => `"${value || '---'}"`,
        },
        'Rider Employee Id': {
          callback: value => `"${value.rider !== null ? `${value.rider.reference_id}` : 'N/A'}"`,
        },
        COD: 'cod',
        'Collected COD': 'collected_cod',
        'Delivery Charge': 'delivery_charge',
        Commission: {
          field: 'commission',
          callback: value => `"${value}"`,
        },
        'Invoice Amount': {
          field: 'invoice_amount',
          callback: value => `"${value}"`,
        },
        'Rider Deposit': {
          field: 'rider_deposit',
          callback: value => `${value.ref_no || '---'}`,
        },
        'Warehouse Deposit': {
          callback: value => `${(value.agency_deposit && value.agency_deposit.ref_no) || (value.branch_deposit && value.branch_deposit.ref_no) || '---'}`,
        },
        Invoice: {
          field: 'merchant_invoice',
          callback: value => `"${value || '---'}"`,
        },
        Status: 'order_current_status.name',
      },
      rows: [],
      selectedWaybillArray: [],
      selectedCard: 'allOrders',
      selectedKey: '',
      attribute: '',
      selectAllCheckbox: false,
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    page() {
      this.fetchOrderList()
    },
    perPage() {
      this.fetchOrderList()
    },
    json_fields() {
      this.fetchOrderList()
    },
  },
  async mounted() {
    this.totalRows = this.rows.length
    await this.initPageData()
    this.fields.push(
      {
        key: 'id',
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'waybill_number',
        label: 'WayBill Number',
        sortable: true,
        thClass: 'text-left',
      },
      {
        key: 'merchant.name',
        label: 'Merchant',
        sortable: true,
        thClass: 'text-left',
      },
      {
        key: 'merchant.type',
        label: 'Merchant Type',
        sortable: false,
        thClass: 'text-center',
      },
      {
        key: 'customer_email',
        label: 'Customer',
        sortable: true,
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'rider_name',
        label: 'Rider',
        sortable: true,
        thClass: 'text-left',
        tdClass: 'text-left',
      },
      {
        key: 'cod',
        label: `COD(${this.currency_type})`,
        sortable: true,
        thClass: ' text-center',
        tdClass: ' text-center',
      },
      {
        key: 'collected_cod',
        label: `Collected Cod(${this.currency_type})`,
        sortable: false,
        thClass: ' text-center',
        tdClass: ' text-center',
      },
      {
        key: 'delivery_charge',
        label: `Delivery Charge(${this.currency_type})`,
        sortable: true,
        thClass: ' text-center',
        tdClass: ' text-center',
      },
      {
        key: 'commission',
        label: `Commission(${this.currency_type})`,
        sortable: true,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'invoice_amount',
        label: `Invoice Amount(${this.currency_type})`,
        thClass: 'text-center',
        tdClass: 'text-center',
        sortable: true,
      },
      {
        key: 'rider_deposit',
        label: 'Rider Deposit',
        sortable: true,
        thClass: 'text-center',
        tdClass: 'text-center',
      },
      {
        key: 'branch_deposit',
        label: 'Warehouse Deposit',
        sortable: true,
        thClass: ' text-center',
        tdClass: ' text-center',
      },
      {
        key: 'merchant_invoice',
        label: 'Invoice',
        sortable: true,
        thClass: ' text-center',
        tdClass: ' text-center',
      },
      {
        key: 'order_current_status.key',
        label: 'Status',
        sortable: true,
        thClass: ' text-center',
        tdClass: 'text-center',
      },
      {
        key: 'action',
        label: 'Action',
        sortable: false,
        thClass: ' text-center',
      },
    )
  },

  methods: {
    async initPageData() {
      try {
        await Promise.all([
          this.fetchOrderList(),
          this.readOrderStatuses(),
          this.financeStatusOptions = JSON.parse(localStorage.getItem('finance_statuses')),
          this.getMerchantList(),
          this.getRiderList(),
          this.readFinanceStatsData(),
        ])
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    async readFinanceStatsData() {
      try {
        this.setStatsLoadingState()
        this.readDataforAllOrderStats(this.filters)
        this.readDataforPendingDeliveryStats(this.filters)
        this.readDataforReturnOrdersStats(this.filters)
        this.readDataforDeliveredOrdersStats(this.filters)
        this.readDataforDeliveryIncomeStats(this.filters)
        this.readDataforCommisionIncomeStats(this.filters)
        this.readDataforToBeInvoicedStats(this.filters)
        this.readDataforPendingDepositStats(this.filters)
        this.readDataforDepositedStats(this.filters)
        this.readDataforApprovedStats(this.filters)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    setStatsLoadingState() {
      const statsObjects = [
        'allOrderStats',
        'pendingDeliveryStats',
        'returnOrdersStats',
        'deliveredOrdersStats',
        'deliveryIncomeStats',
        'commisionIncomeStats',
        'toBeInvoicedStats',
        'pendingDepositStats',
        'depositedStats',
        'approvedStats',
      ]
      statsObjects.forEach(stat => {
        this[stat].count = undefined
        this[stat].total = null
      })
    },
    async readDataforAllOrderStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantAllOrdersStatsFinance(this.filterQuery))
        this.allOrderStats.total = data.all_orders.total
        this.allOrderStats.count = data.all_orders.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforPendingDeliveryStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantPendingDeliveryStatsFinance(this.filterQuery))
        this.pendingDeliveryStats.total = data.pending_delivery_orders.total
        this.pendingDeliveryStats.count = data.pending_delivery_orders.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforReturnOrdersStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantReturnedOrdersStatsFinance(this.filterQuery))
        this.returnOrdersStats.total = data.returned_orders.total
        this.returnOrdersStats.count = data.returned_orders.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforDeliveredOrdersStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantDeliveredOrdersStatsFinance(this.filterQuery))
        this.deliveredOrdersStats.total = data.delivered_orders.total
        this.deliveredOrdersStats.count = data.delivered_orders.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforDeliveryIncomeStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantDeliveryIncomeStatsFinance(this.filterQuery))
        this.deliveryIncomeStats.total = data.delivery_income.total
        this.deliveryIncomeStats.count = data.delivery_income.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforCommisionIncomeStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantCommisionIncomeStatsFinance(this.filterQuery))
        this.commisionIncomeStats.total = data.commission_income.total
        this.commisionIncomeStats.count = data.commission_income.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforToBeInvoicedStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantToBeInvoicedStatsFinance(this.filterQuery))
        this.toBeInvoicedStats.total = data.to_be_invoiced.total
        this.toBeInvoicedStats.count = data.to_be_invoiced.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforPendingDepositStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantPendingDepositStatsFinance(this.filterQuery))
        this.pendingDepositStats.total = data.pending_deposit.total
        this.pendingDepositStats.count = data.pending_deposit.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforDepositedStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantDepositedStatsFinance(this.filterQuery))
        this.depositedStats.total = data.deposited.total
        this.depositedStats.count = data.deposited.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async readDataforApprovedStats() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        this.filterQuery = this.__refineDateQuery(this.filterQuery, [this.filters])
        const { data } = (await OverviewDashboardRepository.getMerchantApprovedStatsFinance(this.filterQuery))
        this.approvedStats.total = data.approved.total
        this.approvedStats.count = data.approved.count
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    addTwoExcelColumns(isAdd = false, noOfColumns = 2) {
      if (isAdd) {
        if (this.json_fields.Description) {
          delete this.json_fields.Description
        }
        if (this.json_fields['Warehouse Deposit']) {
          this.$delete(this.json_fields, 'Warehouse Deposit')
        }
        if (this.json_fields.Status) {
          delete this.json_fields.Status
        }
        if (this.json_fields['Delivered Date']) {
          delete this.json_fields['Delivered Date']
        }
        this.json_fields.Commission = 'commission'
        if (noOfColumns === 2) {
          this.json_fields.Invoice = 'invoice_amount'
        }
        if (noOfColumns === 1) {
          delete this.json_fields.Invoice
        }
        if (noOfColumns === 3) {
          this.json_fields.Invoice = 'invoice_amount'
          this.json_fields['Delivered Date'] = 'status_date'
        }
        this.json_fields.Description = 'description'
        this.$set(this.json_fields, 'Warehouse Deposit', {
          callback: value => {
            const agencyRef = value.agency_deposit !== null ? value.agency_deposit.ref_no : ''
            const branchRef = value.branch_deposit !== null ? value.branch_deposit.ref_no : ''
            return `${agencyRef || branchRef || 'N/A'}`
          },
        })
        this.json_fields.Status = 'order_current_status.name'
      } else {
        if (this.json_fields.Commission) {
          delete this.json_fields.Commission
        }
        if (this.json_fields.Invoice) {
          delete this.json_fields.Invoice
        }
      }
    },
    async fetchOrderList() {
      this.dataLoading = true
      this.rows = []
      const filterQuery = this.buildFilterQuery()
      try {
        if (this.selectedCard === 'allOrders' || this.selectedCard === 'totalFinance' || this.selectedCard === 'totalDC') {
          const { data } = (await FinanceRepository.getMerchantOverviewFinance(this.page, filterQuery, this.perPage))
          this.rows = data.data
          this.meta = data.meta
        } else {
          const { data } = (await FinanceRepository.getMerchantOverviewFinanceByKey(this.page, this.attribute, this.selectedKey, filterQuery, this.perPage))
          this.rows = data.data
          this.meta = data.meta
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
      this.onClickDeselectAll()
    },
    async fetchOrderListNoPagination() {
      try {
        const filterQuery = this.buildFilterQuery()
        const { data } = (await FinanceRepository.getMerchantOverviewFinanceNoPagination(this.attribute, this.selectedKey, filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    onCardSelect(selectedCard, key, attribute, filters) {
      this.selectedKey = key
      this.selectedCard = selectedCard
      this.attribute = attribute
      if (filters) {
        this.filters = {
          status: [filters],
        }
      }
    },
    async readOrderStatuses() {
      this.statusOptions = localStorage.getItem('order_statuses') ? JSON.parse(localStorage.getItem('order_statuses')) : (await OrderRepository.getFullStatusList()).data.data
      if (!localStorage.getItem('order_statuses')) localStorage.setItem('order_statuses', JSON.stringify(this.statusOptions))
    },
    async getMerchantList() {
      this.merchantOptions = localStorage.getItem('merchant_list') ? JSON.parse(localStorage.getItem('merchant_list')) : (await merchantRepository.getMerchantListForDropdown()).data.data
      if (!localStorage.getItem('merchant_list')) localStorage.setItem('merchant_list', JSON.stringify(this.merchantOptions))
    },
    async getRiderList() {
      this.riderOptions = localStorage.getItem('rider_list') ? JSON.parse(localStorage.getItem('rider_list')) : (await riderRepository.getAllRiderDropDown()).data.data
      if (!localStorage.getItem('rider_list')) localStorage.setItem('rider_list', JSON.stringify(this.riderOptions))
    },
    onClickViewOrder(id) {
      this.$refs.viewOrderModal.openModal(id)
    },
    onClickSelectAll() {
      this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
    },
    onClickDeselectAll() {
      this.selectedWaybillArray = []
    },
    async onClickGenerateInvoice() {
      if (this.filters.merchant_id) {
        if (this.filters.merchant_id !== this.rows[0].merchant.id) {
          this.showErrorMessage('Selected orders do not match the selected merchant')
        } else {
          const depositDate = new Date().toISOString().slice(0, 10)
          const deposit = {
            waybill_numbers: this.selectedWaybillArray,
            deposit_date: depositDate,
            expenses: [],
            merchant_id: this.filters.merchant_id,
          }
          this.$refs.deposit_detail_modal.openModal(this.selectedWaybillArray, this.createInvoice, deposit, 'merchant')
        }
      } else {
        this.showErrorMessage('Please filter out a merchant first')
      }
    },
    async createInvoice(invoice) {
      const res = await FinanceRepository.createMerchantInvoice(invoice)
      if (res.status === 201) {
        this.showSuccessMessage('Invoice created Successfully')
        await this.$router.push('/operations/merchant-finance')
      } else {
        this.showErrorMessage('Cannot add invoice')
        await this.$router.push('/operations/merchant-finance')
      }
    },
    onClickPrintDispatch() {
      this.$router.push({
        name: 'print-pod',
        params: {
          selectedWaybills: this.selectedWaybillArray,
        },
      })
    },
    // REQUIRED
    applyFilters() {
      this.fetchOrderList()
      this.onClickDeselectAll()
      this.readFinanceStatsData()
    },
    clearFilters() {
      this.filters = {
        status_date: {
          startDate: null,
          endDate: null,
        },
        invoice_status_date: {
          startDate: null,
          endDate: null,
        },
      }
      this.$nextTick(() => {
        this.fetchOrderList()
      })
    },
    handleChangePage(page) {
      this.page = page
      this.fetchOrderList()
    },
    changePage(value) {
      this.perPage = value
    },
    onWaybillSearch() {
      this.filterName = 'waybill_number'
      this.fetchOrderList()
    },
    onCustomerSearch() {
      this.filterName = 'customer_name'
      this.fetchOrderList()
    },
    onClickMakeRemark(id) {
      this.$refs.add_make_remark.openModal(id)
    },
    onClickFlagDetail(id) {
      this.$refs.flag_detail.openModal(id)
    },
    onClickMakeFutureRequest(id) {
      this.$refs.add_future_request.openModal(id)
    },
    // REQUIRED
    sortChanged(e) {
      const key = e.sortBy
      if (key) {
        const active = e.sortDesc ? '-' : ''
        this.sort = active + key
        this.fetchOrderList()
      }
    },
    onClickRefresh() {
      this.fetchOrderList()
      this.readFinanceStatsData()
    },
    onClickSelectAllCheckbox() {
      if (this.selectAllCheckbox) {
        // If the "Select All" checkbox is checked, select all waybill numbers.
        this.selectedWaybillArray = this.rows.map(n => n.waybill_number)
      } else {
        this.selectedWaybillArray = []
      }
    },
    getCustomerFieldValue(item, fieldName) {
      // If order is encrypted
      if (item.is_encrypted) {
        // If user has permission to view decrypted data, show real values
        if (this.$can('show-decrypted-orders')) {
          // API returns decrypted data when user has permission, so show real value
          return item[fieldName] || ''
        }
        // User doesn't have permission - show masked
        return '******'
      }

      // Order is not encrypted - show normal data
      return item[fieldName] || ''
    },
    shouldShowSecondaryPhone(item) {
      // Show secondary phone if it exists and is not masked
      if (item.is_encrypted && !this.$can('show-decrypted-orders')) {
        return false
      }
      return item.customer_secondary_phone !== null && item.customer_secondary_phone !== ''
    },
  },
}
</script>
<style lang="scss">
@import '../../../@core/scss/vue/libs/vue-select.scss';
</style>
<style>
  .info_icon {
    padding:10px 10px 0 0;
  }
  .tile-warning {
    margin-bottom: 1.5em;
    color: #EB1D36;
  }
</style>
